import {FIRST_STEP} from '../DNFORM-utils/DNFORM-constants';

export const stepperMixin = {
	data() {
		return {
			currentStep: FIRST_STEP,
			doneSteps: []
		};
	},
	computed: {
		totalSteps() {
			return this.steps.length || 1;
		},
		isMultiStepForm() {
			return this.totalSteps > 1;
		},
		isFirstStep() {
			return this.currentStep === FIRST_STEP;
		},
		isLastStep() {
			return this.currentStep === this.totalSteps;
		},
		isSummary() {
			return this.isSummaryEnabled && this.isLastStep;
		}
	},
	methods: {
		changeStep(step) {
			if (step >= FIRST_STEP && step <= this.totalSteps) {
				this.currentStep = Number(step);
			}
		},
		addStepToDoneSteps(step) {
			if (!this.doneSteps.includes(step)) {
				this.doneSteps.push(step);
			}
		}
	}
};



// WEBPACK FOOTER //
// ../source/modules/DNFORM/DNFORM-mixins/DNFORM-stepper-mixin.js